import { type LangFn } from '~/src/polyglot';

// Localized display name for a 2FA auth method. Unknown methods fall back to
// the raw method string.
export const authOptionName = (method: string, lang: LangFn): string => {
  switch (method) {
    case 'email':
      return lang({ message: 'AUTH_OPTION.EMAIL' });
    case 'authenticator':
      return lang({ message: 'AUTH_OPTION.AUTHENTICATOR' });
    case 'sms':
      return lang({ message: 'AUTH_OPTION.SMS' });
    case 'whatsapp':
      return lang({ message: 'AUTH_OPTION.WHATSAPP' });
    default:
      return method;
  }
};
